import * as React from 'react'
import * as SWR from 'hooks/swr'
import * as Icons from 'lucide-react'

import WorkspaceButton from '../workspace-button'
import Logo from 'components/shared/logo'
import IconButton from 'components/shared/icon-button'

import SupportMenu from './components/supportMenu'
import { Separator } from 'components/ui/separator'
import ProfileMenu from 'components/shared/profile-menu'

export const AppBarHeightPixel = 64

export interface LogoAppBarProps {
    open: boolean
    handleMenu: () => void
    children?: JSX.Element
}

export const LogoAppBar = React.memo((props: LogoAppBarProps) => {
    const { data: appData } = SWR.useAppData()

    return (
        <div className="fixed w-full flex justify-between bg-white items-center z-30 border-b">
            <div className="w-11/12 md:px-6 md:w-full mx-auto">
                <div style={{ height: `${AppBarHeightPixel}px` }} className="flex items-center">
                    <div className="flex flex-1">
                        <Logo />
                    </div>
                    <div className="hidden h-full items-center sm:flex gap-1">
                        {!appData?.single_workspace && !process.env.NEXT_PUBLIC_FORCE_WS && <WorkspaceButton />}
                        <Separator decorative orientation="vertical" className="mx-2 bg-neutral-200 h-3/4 w-px" />

                        <SupportMenu />

                        <ProfileMenu />
                    </div>
                    <div className="flex sm:hidden">
                        <IconButton onClick={() => props.handleMenu()}>
                            {!props.open ? <Icons.Menu /> : <Icons.X />}
                        </IconButton>
                    </div>
                </div>
            </div>
        </div>
    )
})

export default LogoAppBar
